
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M6.00009 15H18.0001C18.5501 15 19.0001 14.55 19.0001 14V10.05C19.0001 9.5 18.5501 9.05 18.0001 9.05H6.00009C5.45009 9.05 5.00009 9.5 5.00009 10.05V14C5.00009 14.55 5.45009 15 6.00009 15ZM11.0001 2V3.05C11.0001 3.6 11.4501 4 12.0001 4C12.5501 4 13.0001 3.6 13.0001 3.05V2C13.0001 1.45 12.5501 1 12.0001 1C11.4501 1 11.0001 1.45 11.0001 2ZM18.3401 4.3L17.9601 4.68C17.5701 5.07 17.5701 5.7 17.9601 6.09C18.3501 6.48 18.9801 6.48 19.3701 6.09L19.7501 5.71C20.1401 5.32 20.1401 4.69 19.7501 4.3C19.3601 3.91 18.7301 3.91 18.3401 4.3ZM13.0001 22V21.04C13.0001 20.49 12.5501 20.04 12.0001 20.04C11.4501 20.04 11.0001 20.49 11.0001 21.04V22C11.0001 22.55 11.4501 23 12.0001 23C12.5501 23 13.0001 22.55 13.0001 22ZM19.7401 18.39L19.3501 18C18.9601 17.61 18.3301 17.61 17.9401 18C17.5501 18.39 17.5501 19.02 17.9401 19.41L18.3201 19.8C18.7101 20.19 19.3401 20.19 19.7301 19.8L19.7401 19.79C20.1301 19.41 20.1301 18.77 19.7401 18.39ZM4.25009 5.71L4.64009 6.1C5.03009 6.49 5.66009 6.49 6.05009 6.1C6.44009 5.71 6.44009 5.08 6.05009 4.69L5.66009 4.3C5.27009 3.91 4.64009 3.91 4.25009 4.3C3.87009 4.69 3.87009 5.33 4.25009 5.71ZM5.67009 19.79L6.05009 19.41C6.44009 19.02 6.44009 18.39 6.05009 18C5.66009 17.61 5.03009 17.61 4.64009 18L4.26009 18.38C3.87009 18.77 3.87009 19.4 4.26009 19.79C4.64009 20.18 5.28009 20.18 5.67009 19.79Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-wb-iridescent`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconWbIridescent

    ```js
    <b-new-b-icon-wb-iridescent />
    ```
</docs>


